<template>
    <div class="card card-custom" v-if="task">
        <div class="card-header d-flex">
            <h3 class="card-title align-items-start flex-column" style="width:90%;">
                <input class="form-control-lg w-100" type="text" v-model="task.name" @change="changed = true" />
            </h3>
            <div class="card-toolbar flex-column text-right">
                <button @click="deleteTask()" class="btn btn-danger" data-card-tool="remove">löschen</button>
            </div>
        </div>
        <div class="card-body">
            <div class="d-flex align-items-center mb-2">
                <!--begin::Symbol-->
                <div class="symbol symbol-40 symbol-light-primary mr-5">
                    <div v-if="task.type == 'image'">
                        <button class="btn btn-success">
                            <span class="symbol-label">
                                <span class="svg-icon svg-icon-primary svg-icon-3x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Devices/Camera.svg-->
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
                                         viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <path
                                                d="M5,7 L19,7 C20.1045695,7 21,7.8954305 21,9 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,9 C3,7.8954305 3.8954305,7 5,7 Z M12,17 C14.209139,17 16,15.209139 16,13 C16,10.790861 14.209139,9 12,9 C9.790861,9 8,10.790861 8,13 C8,15.209139 9.790861,17 12,17 Z"
                                                fill="#FFFFFF"/>
                                            <rect fill="#FFFFFF" opacity="0.3" x="9" y="4" width="6" height="2"
                                                  rx="1"/>
                                            <circle fill="#FFFFFF" opacity="0.3" cx="12" cy="13" r="2"/>
                                        </g>
                                    </svg><!--end::Svg Icon-->
                                </span>
                            </span>
                        </button>
                    </div>
                    <div v-else-if="task.type == 'service_price'">
                        <button class="btn btn-danger mb-3">
                            <span class="svg-icon svg-icon-primary svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Navigation/Minus.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect fill="#FFFFFF" x="4" y="11" width="16" height="2" rx="1"/>
                                </g>
                            </svg><!--end::Svg Icon--></span>
                        </button>
                        <div>
                            <button class="btn btn-secondary">
                                <span class="svg-icon svg-icon-primary svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/General/Hidden.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24"/>
                                        <path d="M19.2078777,9.84836149 C20.3303823,11.0178941 21,12 21,12 C21,12 16.9090909,18 12,18 C11.6893441,18 11.3879033,17.9864845 11.0955026,17.9607365 L19.2078777,9.84836149 Z" fill="#000000" fill-rule="nonzero"/>
                                        <path d="M14.5051465,6.49485351 L12,9 C10.3431458,9 9,10.3431458 9,12 L5.52661464,15.4733854 C3.75006453,13.8334911 3,12 3,12 C3,12 5.45454545,6 12,6 C12.8665422,6 13.7075911,6.18695134 14.5051465,6.49485351 Z" fill="#000000" fill-rule="nonzero"/>
                                        <rect fill="#000000" opacity="0.3" transform="translate(12.524621, 12.424621) rotate(-45.000000) translate(-12.524621, -12.424621) " x="3.02462111" y="11.4246212" width="19" height="2"/>
                                    </g>
                                </svg><!--end::Svg Icon--></span>
                            </button>
                        </div>
                    </div>
                    <div v-else-if="task.type == 'service'">
                        <button class="btn btn-success">
                           <span  class="symbol-label">
                               <span class="svg-icon svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/General/Clipboard.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24"/>
                                        <path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#FFFFFF" />
                                        <path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000"/>
                                        <rect fill="#000000" x="7" y="10" width="5" height="2" rx="1"/>
                                        <rect fill="#000000" x="7" y="14" width="9" height="2" rx="1"/>
                                    </g>
                                </svg><!--end::Svg Icon--></span>
                            </span>
                        </button>
                    </div>
                    <div v-else-if="task.type == 'package_return'">
                        <button class="btn btn-warning">
                           <span  class="symbol-label">
                              <span class="svg-icon svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Shopping/Box2.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24"/>
                                        <path d="M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z" fill="#FFFFFF"/>
                                        <path d="M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z" fill="#000000" />
                                    </g>
                                </svg><!--end::Svg Icon--></span>
                            </span>
                        </button>
                    </div>
                    <div v-else-if="task.type == 'package'">
                        <button class="btn btn-success">
                            <span class="svg-icon svg-icon-primary svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Text/Bullet-list.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M10.5,5 L19.5,5 C20.3284271,5 21,5.67157288 21,6.5 C21,7.32842712 20.3284271,8 19.5,8 L10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z M10.5,10 L19.5,10 C20.3284271,10 21,10.6715729 21,11.5 C21,12.3284271 20.3284271,13 19.5,13 L10.5,13 C9.67157288,13 9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M10.5,15 L19.5,15 C20.3284271,15 21,15.6715729 21,16.5 C21,17.3284271 20.3284271,18 19.5,18 L10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 9.67157288,15 10.5,15 Z" fill="#FFFFFF"/>
                                    <path d="M5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 C6.32842712,5 7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 Z M5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 Z M5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 C6.32842712,15 7,15.6715729 7,16.5 C7,17.3284271 6.32842712,18 5.5,18 Z" fill="#000000" />
                                </g>
                            </svg><!--end::Svg Icon--></span>
                        </button>
                    </div>
                    <div v-else-if="task.type == 'package_return'">
                        <button class="btn btn-success">
                           <span  class="symbol-label">
                              <span class="svg-icon svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Shopping/Box2.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24"/>
                                        <path d="M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z" fill="#FFFFFF"/>
                                        <path d="M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z" fill="#FFFFFF" opacity="0.3"/>
                                    </g>
                                </svg><!--end::Svg Icon--></span>
                            </span>
                        </button>
                    </div>
                    <div v-else-if="task.type == 'other_costs'">
                        <button class="btn btn-danger mb-3">
                            <span class="svg-icon svg-icon-primary svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Navigation/Minus.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect fill="#FFFFFF" x="4" y="11" width="16" height="2" rx="1"/>
                                </g>
                            </svg><!--end::Svg Icon--></span>
                        </button>
                        <div>
                            <button class="btn btn-secondary">
                                <span class="svg-icon svg-icon-primary svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/General/Hidden.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24"/>
                                        <path d="M19.2078777,9.84836149 C20.3303823,11.0178941 21,12 21,12 C21,12 16.9090909,18 12,18 C11.6893441,18 11.3879033,17.9864845 11.0955026,17.9607365 L19.2078777,9.84836149 Z" fill="#000000" fill-rule="nonzero"/>
                                        <path d="M14.5051465,6.49485351 L12,9 C10.3431458,9 9,10.3431458 9,12 L5.52661464,15.4733854 C3.75006453,13.8334911 3,12 3,12 C3,12 5.45454545,6 12,6 C12.8665422,6 13.7075911,6.18695134 14.5051465,6.49485351 Z" fill="#000000" fill-rule="nonzero"/>
                                        <rect fill="#000000" opacity="0.3" transform="translate(12.524621, 12.424621) rotate(-45.000000) translate(-12.524621, -12.424621) " x="3.02462111" y="11.4246212" width="19" height="2"/>
                                    </g>
                                </svg><!--end::Svg Icon--></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <div class="form-group">
                                <label v-if="task.type == 'image'" class="text-dark">Bildanzahl exakt</label>
                                <label v-else class="text-dark">Stück</label>
                                <input type="number" class="form-control" v-model="task.quantity" @change="changed = true">
                            </div>
                        </div>
                        <div class="col-12 col-lg-3">
                            <div class="form-group">
                                <label v-if="task.type == 'image'" class="text-dark">Bilder pro Stunde</label>
                                <label v-else class="text-dark">Stück pro Stunde</label>
                                <input type="number" step="1" class="form-control" v-model="task.images_per_hour" @change="changed = true">
                            </div>
                        </div>
                        <div class="col-12 col-lg-3">
                            <div class="form-group">
                                <label v-if="task.type == 'image'" class="text-dark">Preis pro Bild</label>
                                <label v-else class="text-dark">Preis pro Stück</label>
                                <input type="number" class="form-control" v-model="task.price" @change="changed = true">
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label class="text-dark">Weitere Informationen</label>
                                <textarea class="form-control" v-model="task.description" @change="changed = true"></textarea>
                            </div>
                        </div>

                        <div class="col-12 text-right">
                            <button @click="updateTask()" class="btn btn-sm btn-primary" :disabled="!changed">speichern</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="projectTask.type == 'image'" class="card-footer">
            <div  class="d-flex">
                <div class="text-left flex-column">
                    <button class="btn btn-sm btn-dark mr-2" v-html="'Kalkulation'"></button>
                    <button @click="setPrice(135);changed = true;" class="btn btn-sm btn-dark mr-2" v-html="'Bildpreis ' + priceCalc(135)"></button>
                    <button @click="setPrice(120);changed = true;" class="btn btn-sm btn-dark mr-2" v-html="'Bildpreis SLA ' + priceCalc(120)"></button>
                </div>
                <div class="text-right flex-column">
                    <button class="btn btn-sm btn-dark" v-html="'Task Umsatz ' + priceCalcTask()"></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProjectAPI from "~/api/project";

export default {
    props: {
        projectTask: Object,
        estimationRange: Array,
        midAmountArr: Object
    },
    data() {
        return {
            offer: null,
            task: null,
            changed: false
        }
    },
    mounted() {
    },
    created() {
        this.task = this.projectTask;
    },
    methods: {
        updateTask(){
            ProjectAPI.postUpdateProjectTask({
                task: this.task,
            }).then(function (response) {
                if(response.data == "update"){
                    location.reload();
                }
            });
        },
        priceCalc(hourly) {
            let tmp = "n/a";

            if (this.task.images_per_hour && this.task.images_per_hour > 0){
                if (this.task.quantity && this.task.quantity > 0){
                    tmp = (hourly / this.task.images_per_hour) + (hourly / this.task.quantity);

                    tmp = parseFloat(tmp);
                    let formatter = new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    return formatter.format(tmp);
                }
                else if (this.task.estimation_range && this.task.estimation_range != ""){
                    tmp = (hourly / this.task.images_per_hour) + (hourly / this.midAmountArr[this.task.estimation_range]);

                    tmp = parseFloat(tmp);
                    let formatter = new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    return formatter.format(tmp);
                }
            }

            return tmp;
        },
        setPrice(hourly) {
            let tmp = 0;

            if (this.task.images_per_hour && this.task.images_per_hour > 0){
                if (this.task.quantity && this.task.quantity > 0){
                    tmp = (hourly / this.task.images_per_hour) + (hourly / this.task.quantity);

                    tmp = parseFloat(tmp);
                    tmp = Math.round(tmp).toFixed(2)
                }
                else if (this.task.estimation_range && this.task.estimation_range != ""){
                    tmp = (hourly / this.task.images_per_hour) + (hourly / this.midAmountArr[this.task.estimation_range]);

                    tmp = parseFloat(tmp);
                    tmp = Math.round(tmp).toFixed(2)
                }
            }

            this.task.price = tmp;
        },
        priceCalcTask() {
            let tmp = "n/a";

            if (this.task.price && this.task.price > 0){
                if (this.task.quantity && this.task.quantity > 0){
                    tmp = this.task.price * this.task.quantity;

                    tmp = parseFloat(tmp);
                    let formatter = new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    return formatter.format(tmp);
                }
                else if (this.task.estimation_range && this.task.estimation_range != ""){
                    tmp = this.task.price * this.midAmountArr[this.task.estimation_range];

                    tmp = parseFloat(tmp);
                    let formatter = new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    return formatter.format(tmp);
                }
            }

            return tmp;
        },
        deleteTask(){
            ProjectAPI.postDeleteProjectTask({
                task: this.task,
            }).then(function (response) {
                if(response.data == "destroy"){
                    location.reload();
                }
            });
        }
    }
}
</script>
